import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import FAQSection from './components/FAQSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <FAQSection />
        <UpdatesSection />
        <CommentsSection />
        <RankingSection />
        <CarouselSection />
        <CardsSection />
        <MediaSection />
        <AppSection />
        <FeaturesSection />
        <AboutSection />
        <IndexSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}